var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "person-info" },
    [
      _c("div", { staticClass: "template-title" }, [
        _vm._v("参赛人员上传资料")
      ]),
      _vm._v(" "),
      _c("player-info", { staticClass: "player-wrapper" }),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        _vm._l(_vm.datas, function(template, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("p", { staticClass: "template-title" }, [
                _vm._v(_vm._s(template.title))
              ]),
              _vm._v(" "),
              _c("file-uploader", {
                attrs: {
                  canDownload: _vm.download,
                  fileDesc: template.desc,
                  type: template.type,
                  status: _vm.status,
                  activityId: _vm.activity_id,
                  playerId: _vm.player_id,
                  hidenFileStatus: true
                },
                on: { downloadAttachment: _vm.downloadAttachment },
                model: {
                  value: template.materials,
                  callback: function($$v) {
                    _vm.$set(template, "materials", $$v)
                  },
                  expression: "template.materials"
                }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-203b01a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-203b01a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DownloadAll.vue
// module id = null
// module chunks = 